<nav class="breadcrumb-nav">
  <div *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a *ngIf="breadcrumb.url" [routerLink]="breadcrumb.url" class="mat-button breadcrumb-button">{{ breadcrumb.label }}</a>
    <span class="mat-button breadcrumb-button-gray" *ngIf="!breadcrumb.url">{{ breadcrumb.label }}</span>
    <span *ngIf="!last" class="breadcrumb-divider"> > </span>
  </div>
</nav>
